import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectThemeMode } from "../../redux/features/theme/theme-slice";

export const useTheme = (): "light" | "dark" => {
  const themeMode = useSelector(selectThemeMode);
  const [effectiveTheme, setEffectiveTheme] = useState<"light" | "dark">(() => {
    if (themeMode === "dark") return "dark";
    if (themeMode === "light") return "light";
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });

  useEffect(() => {
    const getEffectiveTheme = (): "light" | "dark" => {
      if (themeMode === "dark") return "dark";
      if (themeMode === "light") return "light";
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    };

    const currentTheme = getEffectiveTheme();
    setEffectiveTheme(currentTheme);
    document.documentElement.setAttribute("data-theme", currentTheme);

    const handleSystemThemeChange = (e: MediaQueryListEvent) => {
      if (themeMode === "system") {
        const theme = e.matches ? "dark" : "light";
        setEffectiveTheme(theme);
        document.documentElement.setAttribute("data-theme", theme);
      }
    };

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    if (themeMode === "system") {
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener("change", handleSystemThemeChange);
      } else {
        mediaQuery.addListener(handleSystemThemeChange);
      }
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleSystemThemeChange);
      } else {
        mediaQuery.removeListener(handleSystemThemeChange);
      }
    };
  }, [themeMode]);

  return effectiveTheme;
};
